<template>
    <div class="bg-white py-10 flex flex-col w-full">
        <div class="bg-GRIS_CLARO py-4 flex flex-col w-full items-center">
            <h2 class="md:text-2xl text-xl font-bold text-GRIS_LEON text-center">Todos nuestros servicios incluyen:</h2>
            <div class="justify-items-center w-full max-w-[76rem] grid md:grid-cols-3 grid-cols-2 py-10 px-2 md:px-0 gap-4 md:gap-0">
                <div
                    class="flex flex-col justify-center items-center gap-2 bg-white rounded-lg p-4 max-w-[200px] w-full shadow-md">
                    <img src="/img/newhome/servicios-incluidos/garantia.gif" alt="diagnostico"
                        class="w-[100px] object-contain" draggable="false" loading="lazy" decoding="async">
                    <p class="text-center text-GRIS_LEON font-bold text-sm">
                        Garantía 6 Meses o 10.000 KMS
                    </p>
                </div>

                <div
                    class="flex flex-col justify-center items-center gap-2 bg-white rounded-lg p-4 max-w-[200px] w-full shadow-md">
                    <img src="/img/newhome/servicios-incluidos/servicio-express.gif" alt="diagnostico"
                        class="w-[100px] object-contain" draggable="false" loading="lazy" decoding="async">
                    <p class="text-center text-GRIS_LEON font-bold text-sm">
                        Servicio Express
                    </p>
                </div>

                <!--
                    <div
                        class="flex flex-col justify-center items-center gap-2 bg-white rounded-lg p-4 max-w-[200px] w-full shadow-md">
                        <img src="/img/newhome/servicios-incluidos/revision.gif" alt="diagnostico"
                            class="w-[100px] object-contain" draggable="false">
                        <p class="text-center text-GRIS_LEON font-bold text-sm">
                            Revisión de Seguridad de 13 Puntos GRATIS
                        </p>
                    </div>
                -->

                <div
                    class="flex flex-col justify-center items-center gap-2 bg-white rounded-lg p-4 max-w-[200px] w-full shadow-md">
                    <img src="/img/newhome/servicios-incluidos/diagnostico.gif" alt="diagnostico"
                        class="w-[100px] object-contain" draggable="false" loading="lazy" decoding="async">
                    <p class="text-center text-GRIS_LEON font-bold text-sm">
                        Diagnosticamos a tu auto
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

</script>

<style scoped></style>
